export default {
    CASE_TYPE_DELAYED: {
        value: 0,
        title: '... war 3 Stunden oder mehr verspätet.'
    },
    CASE_TYPE_CANCELED: {
        value: 1,
        title: '... wurde annuliert.'
    },
    CASE_TYPE_NO_BOARDING: {
        value: 2,
        title: '... konnte nicht wahrgenommen werden, da das Boarding untersagt wurde.'
    },
    CASE_TYPE_FORWARDED: {
        value: 3,
        title: '... wurde um mehr als 1 Stunde vorverlegt.'
    },
    toArray() {
        return [
          this.CASE_TYPE_DELAYED,
          this.CASE_TYPE_CANCELED,
          this.CASE_TYPE_NO_BOARDING,
          this.CASE_TYPE_FORWARDED
        ];
    }
}